import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/app/auth';
import { api } from '@/lib/api';
import type { Subscription } from './types';

export function useSubscription() {
  const isAuthenticated = useAuth((s) => s.isAuthenticated);
  return useQuery({
    queryKey: ['subscription'],
    queryFn: () => api.get<Subscription>('/api/me/subscription/'),
    enabled: isAuthenticated,
  });
}
